export const consignmentOrders = 'Dispatched Orders'
export const hourlyReceivingOrders = 'Hourly Receiving Orders'
export const consignmentExpense = 'Consignment Expense'
export const courierExpenditure = 'Courier Expenditure Orders'
export const dailyManifestation = 'Daily Manifestation Orders'
export const manifestReportsArchive = 'Manifest Reports Archive'
